// utils/isIncognito.js
export async function isIncognito() {
  // Chrome / Edge / Opera detection
  const fs = window.RequestFileSystem || window.webkitRequestFileSystem;
  if (fs) {
    return new Promise((resolve) => {
      fs(window.TEMPORARY, 100, () => resolve(false), () => resolve(true));
    });
  }

  // Firefox detection — refined quota + persist test
  if ('storage' in navigator && 'estimate' in navigator.storage) {
    try {
      const { quota } = await navigator.storage.estimate();

      // Typical private mode quota is ~0–100 MB vs 2GB+ in normal
      if (quota && quota < 150 * 1024 * 1024) return true;

      // In normal mode, persisted storage is allowed
      if (navigator.storage.persisted) {
        const persisted = await navigator.storage.persisted();
        if (!persisted) return true;
      }

      return false;
    } catch {
      return true;
    }
  }

  // Safari / iOS detection via IndexedDB
  try {
    return await new Promise((resolve) => {
      const db = indexedDB.open('test');
      db.onerror = () => resolve(true);
      db.onsuccess = () => {
        db.result.close();
        indexedDB.deleteDatabase('test');
        resolve(false);
      };
    });
  } catch {
    return true;
  }
}
